<template>
  <el-dialog
    title="退款单详情"
    :visible.sync="dialogVisible"
    width="65%"
    :before-close="handleClose">
    <div class="refund-content">
      <el-row :gutter="10">
        <el-col :span="12">
          <div class="refund-card">
            <div class="refund-card-title">基础信息</div>
            <div class="card-group">
              <div class="card-group-label">订单编号：</div>
              <div class="card-group-value">{{ refundData.orderNumber }}</div>
            </div>
            <div class="card-group">
              <div class="card-group-label">退款单号：</div>
              <div class="card-group-value">{{ refundData.asOid }}</div>
            </div>
            <div class="card-group">
              <div class="card-group-label">退款金额：</div>
              <div class="card-group-value">￥{{ refundData.applyAmount | decimal }}</div>
            </div>
            <div class="card-group" v-if="refundData.refundDeliveryCashAmount">
              <div class="card-group-label">自付运费金额：</div>
              <div class="card-group-value">￥{{ refundData.refundDeliveryCashAmount | decimal }}</div>
            </div>
            <div class="card-group" v-if="refundData.refundDeliveryYhAmount">
              <div class="card-group-label">储值运费金额：</div>
              <div class="card-group-value">￥{{ refundData.refundDeliveryYhAmount | decimal }}</div>
            </div>
            <div class="card-group">
              <div class="card-group-label">申请时间：</div>
              <div class="card-group-value">{{refundData.createTime}}</div>
            </div>
            <div class="card-group">
              <div class="card-group-label">退款原因：</div>
              <div class="card-group-value">{{ refundData.reasonLabel }}</div>
            </div>
            <div class="card-group">
              <div class="card-group-label">退款备注：</div>
              <div class="card-group-value">{{ refundData.remarks }}</div>
            </div>
            <div class="card-group">
              <div class="card-group-label">相关图片：</div>
              <div class="card-group-value">
                <el-image :src="refundData.remarksImg" fit="contain" class="picture"></el-image>
              </div>
            </div>
            <div class="card-group">
              <div class="card-group-label">退款状态：</div>
              <div class="card-group-value" :class="{'red': refundData.status === 17}">{{ stateMaps[refundData.status] }}</div>
            </div>
            <div class="card-group" v-if="refundData.status === 17">
              <div class="card-group-label">拒绝原因：</div>
              <div class="card-group-value" :class="{'red': refundData.status === 17}">{{ refundData.auditMemo }}</div>
            </div>
          </div>
          <div class="refund-card" style="margin-top: 10px;" v-if="refundData.regHandlerStatus !== 'NONE'">
            <div class="refund-card-title">平台介入信息</div>
            <div class="card-group">
              <div class="card-group-label">平台介入状态：</div>
              <div class="card-group-value">{{platformState[refundData.regHandlerStatus]}}</div>
            </div>
            <div class="card-group">
              <div class="card-group-label">买家申请时间：</div>
              <div class="card-group-value">{{refundData.regHandlerApplyTime}}</div>
            </div>
            <div class="card-group">
              <div class="card-group-label">买家申请备注：</div>
              <div class="card-group-value">{{refundData.regHandlerApplyMemo}}</div>
            </div>
            <div class="card-group" v-if="refundData.regHandlerTime">
              <div class="card-group-label">平台处理时间：</div>
              <div class="card-group-value">{{refundData.regHandlerTime}}</div>
            </div>
            <div class="card-group" v-if="refundData.regHandlerMemo">
              <div class="card-group-label">平台处理回复：</div>
              <div class="card-group-value">{{  refundData.regHandlerMemo }}</div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="refund-card">
            <div class="refund-card-title">退款商品</div>
            <div class="card-group">
              <div class="card-group-label">卖家：</div>
              <div class="card-group-value">{{ refundData.merchantName }}</div>
            </div>
            <div class="card-group">
              <div class="card-group-label">退款商品：</div>
              <div class="card-group-value top">
                <div class="good" v-for="good in refundData.goodList" :key="good.bxysid">
                  <el-image class="good-cover fl" :src="good.goodImg" fit="contain"></el-image>
                  <div class="good-info">
                    <div  @click="$tools.showGoodInBlank(good.commodityId)" class="good-title u-line-two">{{good.goodsName}}</div>
                    <div class="good-sku">{{good.bxysName}}</div>
                    <div class="good-count">
                      <span class="price">￥{{ good.orgTotalAmount | decimal }}</span>
                      <span class="count">×{{ good.orgBuyCount || 1 }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="dialog-footer" slot="footer">
      <el-button type="warning" @click="doCancel" v-if="refundData.status <= 15">取消退款</el-button>
    </div>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'refundDetail',
  data() {
    return {
      dialogVisible: false,
      refundData: '',
      stateMaps: {
        11: '提交退单',
        12: '退单审核',
        13: '收货确认',
        14: '退款确认',
        15: '收款确认',
        16: '完成',
        17: '已拒绝退款',
        18: '已取消'
      },
      platformState: {
        'NONE': '无平台介入',
        'APPLY': '平台介入中',
        'REFUND': '平台退款',
        'REJECT': '平台驳回'
      }
    }
  },
  methods: {
    doCancel () {
      this.$emit('cancel', this.refundData);
      this.hideDialog();
    },
    handleClose (done) {
      done();
    },
    showDialog (order) {
      this.refundData = order;
      this.dialogVisible = true;
    },
    hideDialog () {
      this.dialogVisible = false;
      this.refundData = null;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
.refund-card{
  border: 1px solid #efefef;
  .refund-card-title{
    font-size: 14px;
    font-weight: 500;
    padding: 5px 10px;
    border-bottom: 1px solid #efefef;
  }
  .card-group{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 5px 10px;
    .card-group-label{
      width: 120px;
      color: #888888;
    }
    .card-group-value{
      flex: 1;
      &.red{
        color: var(--main-theme-color);
      }
      .picture{
        width: 80px;
        height: 80px;
      }
    }
  }
}
.good{
  margin-bottom: 10px;
  .good-cover{
    width: 80px;
    height: 80px;
    margin-right: 10px;
    border-radius: 5px;
  }
  .good-title{
    height: 40px;
  }
  .good-count{
    display: flex;
    justify-content: space-between;
    align-self: center;
    .price{
      color: var(--main-theme-color);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/myOrder/customerService/refundDetail.vue